import React from "react";

const CGU_SECTIONS = [
  {
    title: "1. Objet",
    content:
      "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation de la plateforme PixyQuiz, accessible depuis le site internet de PixyQuiz. En accédant au site, l'utilisateur accepte sans réserve les présentes CGU.",
  },
  {
    title: "2. Accès au service",
    content:
      "L'accès au service est ouvert à toute personne physique disposant de la capacité juridique. Certaines fonctionnalités sont réservées aux utilisateurs inscrits et connectés. PixyQuiz se réserve le droit de suspendre ou de supprimer tout compte ne respectant pas les présentes CGU.",
  },
  {
    title: "3. Création de compte",
    content:
      "Pour accéder aux fonctionnalités complètes, l'utilisateur doit créer un compte en fournissant un pseudo, une adresse e-mail valide et un mot de passe. L'utilisateur est responsable de la confidentialité de ses identifiants et de toute activité effectuée depuis son compte.",
  },
  {
    title: "4. Règles de conduite",
    content:
      "L'utilisateur s'engage à ne pas publier de contenu illicite, diffamatoire, injurieux ou portant atteinte aux droits des tiers. Tout comportement irrespectueux dans le tchat de jeu, les forums ou les commentaires pourra entraîner une suspension ou un bannissement du compte.",
  },
  {
    title: "5. Propriété intellectuelle",
    content:
      "L'ensemble des contenus présentés sur PixyQuiz (textes, images, logos, graphismes) est la propriété exclusive de PixyQuiz ou de ses partenaires. Toute reproduction, distribution ou utilisation sans autorisation expresse est interdite.",
  },
  {
    title: "6. Responsabilités",
    content:
      "PixyQuiz ne saurait être tenu responsable des interruptions de service, pertes de données ou dommages indirects liés à l'utilisation de la plateforme. Le service est fourni « en l'état » et peut faire l'objet de maintenances ou d'interruptions.",
  },
  {
    title: "7. Modification des CGU",
    content:
      "PixyQuiz se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification significative. La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles CGU.",
  },
  {
    title: "8. Droit applicable",
    content:
      "Les présentes CGU sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution sera soumis aux tribunaux compétents du ressort du siège social de PixyQuiz.",
  },
];

export default function Cgu() {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-600">
            LÉGAL
          </p>
          <h1 className="mt-3 text-4xl font-black text-slate-950">
            Conditions Générales d'Utilisation
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {CGU_SECTIONS.map((section) => (
            <div
              key={section.title}
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
            >
              <h2 className="text-lg font-black text-slate-950">
                {section.title}
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
